import { forwardRef, useEffect, useRef, useState } from "react";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import {
  Card,
  CardContent,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import {
  appColor,
  constants,
  EndPoint,
  headers,
  messages,
} from "../../common/constants";
import LocatesKpi from "../../components/LocateKpi";
import moment from "moment";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import axios from "axios";
import _ from "lodash";
import { getDivHeight, mapRowId } from "../../common/commonFunctions";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab, styled } from "@mui/material";
import { Icon } from "@iconify/react";
import MuiTabList, { TabListProps } from "@mui/lab/TabList";
import LocateAdders from "../../components/LocateAdders";
import LocatesGrid from "../../components/LocatesGrid";
import PreBorrowGrid from "../../components/PreBorrowGrid";
import MostLocatesGrid from "../../components/MostLocatedGrid";
import React from "react";
import { Split } from "@geoffcox/react-splitter";
import CommonAgGrid from "../../components/CommonAgGrid";
import { locateSupplyColDef } from "../../common/columnSupply";
import EnquiryGridWorkbook from "../../components/EnquiryGridWorkbook";
import EnquiryGrid from "../../components/EnquiryGrid";
import { isServiceHealthy } from "../../utils/API";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const TabList = styled(MuiTabList)<TabListProps>(({ theme }) => ({
  borderBottom: "0 !important",
  "&, & .MuiTabs-scroller": {
    boxSizing: "content-box",
    padding: theme.spacing(1.25, 1.25, 2),
    margin: `${theme.spacing(-1.25, -1.25, -2)} !important`,
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .Mui-selected": {
    boxShadow: theme.shadows[2],
    backgroundColor: `${appColor}`,
    color: `${theme.palette.common.white} !important`,
  },
  "& .MuiTab-root": {
    lineHeight: 1,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      color: `${appColor}`,
    },
  },
}));

const LocateDashboard = () => {
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [locateKPI, setLocateKPI] = useState<any>([]);
  let accountId = window.localStorage.getItem("activeAccountCode");
  const [date, setDate] = useState(moment().toDate());
  const [isInitialRefresh, setIsInitialRefresh] = useState(true);
  const [selectedTab, setSelectedTab] = useState<string>("Enquiry");
  const tabListRef = useRef(null);
  const [isLocatesRefreshed, setIsLocatesRefreshed] = useState<boolean>(false);
  const [isPreBorrowsRefreshed, setIsPreBorrowsRefreshed] =
    useState<boolean>(false);
  const [isMostLocatedRefreshed, setIsMostLocatedRefreshed] =
    useState<boolean>(false);
  const [currentGridRef, setCurrentGridRef] = useState<any>(null);
  const [currentGridApi, setCurrentGridApi] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [newRows, setNewRows] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [hideLocateKpi, setHideLocateKpi] = useState<any>(true);
  const [supplyRows, setSupplyRows] = useState<any>([]);
  const [locateHeight, setLocateHeight] = useState<any>("");
  const [locateSupplyGridRef, setLocateSupplyGridRef] = useState<any>(null);
  const [locateMostGridRef, setLocateMostGridRef] = useState<any>(null);
  const [selectedTickerCode, setSelectedTickerCode] = useState<any>(null);
  const [currentLocateGrid, setCurrentLocateGrid] = useState("locate");
  const [sourceFilter, setSourceFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [currentClient, setCurrentClient] = useState("");
  const [clientOptions, setClientOptions] = useState<any>([]);
  const [clientShortNameList, setClientNameList] = useState<any>([]);
  const [isSmallerDeviceRes, setIsSmallerDeviceRes] = useState<boolean>(
    window?.innerWidth <= 992
  );
  const [showTotalRow, setShowTotalRow] = useState(false);

  const [isResetFilter, setIsResetFilter] = useState<boolean>(false);
  const [initSupplyRows, setInitSupplyRows] = useState<any>([]);
  const [enableSocketUpdates, setEnableSocketUpdates] = useState<boolean>(true);
  const refreshIntervals = [
    { label: "5 sec", value: 5000 },
    { label: "10 sec", value: 10000 },
    { label: "15 sec", value: 15000 },
    { label: "5 min", value: 300000 },
    { label: "10 min", value: 600000 },
    { label: "15 min", value: 900000 },
    { label: "Off", value: 0 },
  ];
  const [currentInterval, setCurrentInterval] = useState(5000);
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const [isDeselectAll, setIsDeselectAll] = useState<boolean>(false);
  const [inputTicker, setTickerInput] = useState("");
  const [isInquiriesRefreshed, setIsInquiriesRefreshed] =
    useState<boolean>(false);
  const [isShowFilledLocates, setIsShowFilledLocates] =
        useState<boolean>(false);
  const [locateRequest, setLocateRequest] = useState<any>(null);
  const [isRefreshTickerKPI, setIsRefreshTickerKPI] = useState<boolean>(false);
  const [currentKPITicker, setCurrentKPITicker] = useState<any>(null);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const getLocatesKPI = async () => {
    try {
      setLocateKPI([]);
      const request = {
        date: moment(date).format("YYYY-MM-DD"),
        account: accountId,
        clientShortCode:
          currentClient === "all" || _.isEmpty(currentClient)
            ? null
            : currentClient,
      };

      const token = window.localStorage.getItem("refreshtoken");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getLocateKPI}`,
          JSON.stringify(request),
          {
            headers: headers,
          }
        )
        .then(async (response: any) => {
          if (!response) {
            setOpen(true);
            setSnackbarMessage("Locate" + messages.serviceDownMessage);
          }

          if (response?.status === 200) {
            const rows = await response?.data;
            if (rows && _.isArray(rows) && rows?.length > 0) {
              setLocateKPI(rows);
            } else {
              setLocateKPI([]);
            }
          } else if (response?.status === 401) {
            //logout(channel)
          } else {
            setLocateKPI([]);
          }
        });
    } catch (err) {
      setLocateKPI([]);
    }
  };

  useEffect(() => {
    if (!isInitialRefresh && date && !_.isUndefined(date)) {
      getLocatesKPI();
    }
    getSupplyServiceHealth();
  }, [date, currentClient]);

  useEffect(() => {
    if (isInitialRefresh) {
      getLocateServiceHealth();
      setIsInitialRefresh(false);
    }
  }, [isInitialRefresh]);

  const refreshLocates = () => {
    setIsLocatesRefreshed(!isLocatesRefreshed);
  };

  const refreshPreBorrows = () => {
    setIsPreBorrowsRefreshed(!isPreBorrowsRefreshed);
  };

  const refreshMostLocated = () => {
    setIsMostLocatedRefreshed(!isMostLocatedRefreshed);
  };

  const refreshInquiries = () => {
    setIsInquiriesRefreshed(!isInquiriesRefreshed);
  };

  const handleChange = (event: any, newValue: string) => {
    setSelectedTab(newValue);
    setSelectedRow(null);
    setNewRows([]);
  };

  const getCardHeight = () => {
    const kpiHeight = document?.getElementById("locate-kpi-id")?.offsetHeight;
    const divHeight = _.isUndefined(kpiHeight) ? 22 : kpiHeight + 300;
    return window?.innerWidth > 999
      ? "calc(100vh - " + divHeight + "px)"
      : "60vh";
  };

  const getMLCardHeight = (extraSpace: number = 0) => {
    const kpiHeight = document?.getElementById("locate-kpi-id")?.offsetHeight;
    const divHeight = _.isUndefined(kpiHeight)
      ? 22
      : kpiHeight +
        (selectedTab === "Most Located" || selectedTab === "Enquiry"
          ? 230
          : 420);
    return window?.innerWidth > 999
      ? "calc(100vh - " + (divHeight + extraSpace) + "px)"
      : "70vh";
  };

  const insertNewRow = (rows: any) => {
    if (selectedTab === "Locates") {
      const data = rows?.map((row: any) => {
        return {
          ...row,
          centpershare: _.isNaN(row?.centpershare)
            ? ""
            : row?.centpershare?.toFixed(4),
          centpershare_appr: _.isNaN(row?.centpershare_appr)
            ? ""
            : row?.centpershare_appr?.toFixed(4),
          rebate: !_.isNaN(row?.rebate) ? (+row?.rebate)?.toFixed(4) : "",
          rate_appr: _.isNaN(row?.rate_appr) ? "" : (+row?.rate_appr)?.toFixed(4),
        };
      });
      setNewRows(data);
    } else {
      setNewRows(rows);
    }
  };

  const getSupplyInfo = async () => {
    try {
      //Todo: use below data when we have perfect data

      setSupplyRows([]);
      setInitSupplyRows([]);
      const request = { date_in: moment(date).format("YYYY-MM-DD") };
      let accountId = window.localStorage.getItem("activeAccountCode");
      const token = window.localStorage.getItem("refreshtoken");
      const header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getLenderDetails}?account_id=` +
            accountId,
          request,
          { headers: header }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true);
            setSnackbarMessage("Supply" + messages.serviceDownMessage);
          } else {
            const data = response?.data;
            if (data && !_.isEmpty(data)) {
              const mappedRows = mapRowId(data);
              const updatedRows = mappedRows.map((r: any) => ({
                ...r,
                qty: !_.isEmpty(r.qty) ? parseFloat(r.qty) : 0,
                rate: !_.isEmpty(r.rate) ? parseFloat(r.rate) : 0,
                price: !_.isEmpty(r.price) ? parseFloat(r.price) : 0,
                value: !_.isEmpty(r.value) ? parseFloat(r.value) : 0,
              }));
              setSupplyRows(updatedRows);
              setInitSupplyRows([...updatedRows]);
            } else {
              setSupplyRows([]);
              setInitSupplyRows([]);
            }
          }
        });
    } catch (err) {
      setSupplyRows([]);
      setInitSupplyRows([]);
    } finally {
    }
  };

  useEffect(() => {
    const height = getCardHeight();
    setLocateHeight(height);
  }, [hideLocateKpi]);

  useEffect(() => {
    const height = getCardHeight();
    setLocateHeight(height);
    getAuthServiceHealth();
  }, []);

  useEffect(() => {
    if (selectedTab === "Pre Borrow") {
      setSelectedTickerCode(selectedRow?.sec_id);
    } else if (selectedTab === "Locates") {
      setSelectedTickerCode(
        _.isUndefined(selectedRow?.ticker)
          ? selectedRow?.secid
          : selectedRow?.ticker
      );
    } else {
      setSelectedTickerCode(selectedRow?.ticker);
    }
  }, [selectedRow]);

  const getClients = async () => {
    try {
      await axios
        .get(
          `${serviceAPIMapping["AUTH-SERVICE"].apiRouteURL}${EndPoint.authBase}${EndPoint.getClientEntityDetails}`,
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          if (response?.status === 200) {
            const locateClients = _.uniqBy(response?.data, "clientName");
            const uniqueClients = _.filter(locateClients, [
              "clientType",
              "Locate",
            ]);
            setClientOptions(uniqueClients);
            const clientShortNames = uniqueClients?.map((c: any) => {
              return c?.shotName;
            });
            setClientNameList(clientShortNames);
          }
        });
    } catch (err) {}
  };

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      setIsSmallerDeviceRes(window.innerWidth <= 992);
    }

    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const intiRows = [...initSupplyRows];
    setSupplyRows(intiRows);
  }, [isResetFilter]);

  useEffect(() => {
    if (inputTicker) {
      const initRows = [...initSupplyRows];
      const rows = initRows?.filter((row: any) => row?.ticker === inputTicker);
      setSupplyRows(rows);
    } else {
      const intiRows = [...initSupplyRows];
      setSupplyRows(intiRows);
    }
  }, [inputTicker]);

  const toggleRealTimeData = () => {
    setEnableSocketUpdates(!enableSocketUpdates);
  };

  const getSupplyServiceHealth = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`Supply${messages.serviceDownMessage}`);
        setOpen(true);
      } else {
        getSupplyInfo();
      }
    });
  };

  const getLocateServiceHealth = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`Locate${messages.serviceDownMessage}`);
        setOpen(true);
      } else {
        getLocatesKPI();
      }
    });
  };

  const getAuthServiceHealth = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["AUTH-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`Locate${messages.serviceDownMessage}`);
        setOpen(true);
      } else {
        getClients();
      }
    });
  };


  const onCurrentKPITickerChange = (ticker: any)=>{
    if(selectedTab === 'Locates'){
       setCurrentKPITicker(ticker)
    }
     
  }

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {doShowFullScreenLoader && <SpinnerFullScreen />}
      <div className="col p-0 mx-auto w-100 mt-10 col-12 col-md-6 mb-2 ">
       <div className="col p-0 mx-auto w-100 mt-10 col-12 col-md-6 mb-2 ">
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
    <div
      className="row mx-auto title-subHeaderTitle dtc-title justify-content-start mb-2 mb-md-0"
      style={{ height: "1.5rem", width:'90%' }}
    >
      Locates Admin Dashboard
    </div>
    <div
      className="d-flex flex-wrap gap-2 justify-content-start justify-content-md-end me-3"
      aria-disabled
    >
      <div className="d-flex flex-row justify-content-between me-2 align-items-bottom">
        <div className={`mt-1 me-2`}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableFuture
              openTo="day"
              className="onFocusOutTermDateID"
              views={["year", "month", "day"]}
              maxDate={moment().toDate()}
              value={date}
              inputFormat="yyyy-MM-dd"
              InputProps={{
                notched: false,
                style: { fontSize: 13, color: "#212529" },
              }}
              onChange={(newValue: any) => {
                setDate(newValue);
              }}
              renderInput={(params: any) => (
                <TextField
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      height: "0.4rem",
                      padding: "12px 10px 12px",
                    },
                    "& .MuiInputAdornment-root": {
                      marginLeft: "0px",
                    },
                  }}
                  className={`locate-kpi-date-picker ${
                    moment().isAfter(date, "day") ? "past-date-bg" : ""
                  }`}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
        <div className="me-2 auto-complete-padding py-1">
          <select
            className="locates-select w-auto"
            value={currentClient}
            onChange={(e: any) => {
              setCurrentClient(e?.target?.value);
            }}
          >
            <option className="locates-select" key={"all"} value={"all"}>
              All
            </option>
            {clientOptions?.map((client: any) => {
              return (
                <>
                  <option
                    className="locates-select"
                    key={client?.shortName}
                    value={client?.shortName?.trim()}
                  >
                    {client?.shortName?.trim()}
                  </option>
                </>
              );
            })}
          </select>
        </div>
        <div className="me-2 auto-complete-padding py-1">
          <select
            className="locates-select w-auto"
            value={currentInterval}
            disabled={enableSocketUpdates}
            onChange={(e: any) => {
              setCurrentInterval(e?.target?.value);
            }}
          >
            {refreshIntervals?.map((interval: any) => {
              return (
                <>
                  <option
                    className="locates-select"
                    key={interval?.value}
                    value={interval?.value}
                  >
                    {interval?.label}
                  </option>
                </>
              );
            })}
          </select>
        </div>
        <div className="form-check form-switch d-flex align-self-center">
          <input
            checked={enableSocketUpdates}
            onChange={() => toggleRealTimeData()}
            className="form-check-input me-2"
            type="checkbox"
            role="switch"
            id="flexSwitchCheckDefault"
            title="Turn on/off real time data"
          />
          <label
            className="form-check-label text-nowrap mb-0 align-self-center"
            style={{ fontSize: "small" }}
            htmlFor="flexSwitchCheckDefault"
            title="Turn on/off real time data"
          >
            Real Time Data
          </label>
        </div>
      </div>
    </div>
  </div>

  <div className="w-100" id="locate-kpi-id">
    <Card sx={{ backgroundColor: hideLocateKpi ? "" : "#ffffff00" }}>
      <CardContent className="py-0 d-flex flex-row">
        {locateKPI && !hideLocateKpi && (
          <LocatesKpi
            kpiData={locateKPI}
            setDate={(date: any) => {
              setDate(date);
            }}
            isAdmin={true}
          />
        )}

        {!hideLocateKpi && (
          <Icon
            icon={"ep:arrow-up-bold"}
            className="ms-3 d-flex justify-content-end pe-0 cursor-pointer"
            onClick={() => setHideLocateKpi(!hideLocateKpi)}
          ></Icon>
        )}

        {hideLocateKpi && (
          <>
            <div className="d-flex flex-row justify-content-between w-100">
              <Typography className="ms-2 d-flex justify-content-start pe-0">
                Locate KPI
              </Typography>
              <Icon
                icon={"ep:arrow-down-bold"}
                
                className="ms-3 d-flex justify-content-end pe-0 cursor-pointer"
                onClick={() => setHideLocateKpi(!hideLocateKpi)}
              ></Icon>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  </div>
  
      </div>

        <div className="w-100 mt-1" style={{ height: locateHeight }}>
          <Card>
            <CardContent className="w-100 p-1">
              <div style={{ height: "100%" }} className="w-100 pt-1">
                <TabContext value={selectedTab}>
                  <div className="h-100" id="locate-tabs">
                    <TabList
                      variant="scrollable"
                      id="locate-tab-list"
                      ref={tabListRef}
                      scrollButtons="auto"
                      onChange={handleChange}
                      aria-label="locate-tab-list"
                      sx={{ minHeight: "30px" }}
                    >
                      <Tab
                        value="Enquiry"
                        className="px-3 py-1"
                        sx={{ minHeight: "30px" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                              className: "py-0 my-0",
                            }}
                          >
                            <Icon fontSize="1.0rem" icon="tabler:search" />
                            {"Inquiry"}
                          </Box>
                        }
                      />

                      <Tab
                        value="Locates"
                        className="px-3 py-1"
                        sx={{ minHeight: "30px" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                              className: "py-0 my-0",
                            }}
                          >
                            <Icon fontSize="1.0rem" icon="tabler:user" />
                            {"Locates"}
                          </Box>
                        }
                      />
                      <Tab
                        value="Pre Borrow"
                        sx={{ minHeight: "30px" }}
                        className="px-3 py-1"
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                            }}
                          >
                            <Icon fontSize="1.25rem" icon="tdesign:money" />
                            {"Pre Borrow"}
                          </Box>
                        }
                      />
                      <Tab
                        value="Most Located"
                        sx={{ minHeight: "30px" }}
                        className="px-3 py-1"
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                            }}
                          >
                            <Icon fontSize="1.25rem" icon="tabler:users" />
                            {"Most Located"}
                          </Box>
                        }
                      />
                    </TabList>
                  </div>
                  {(selectedTab === "Locates" ||
                    selectedTab === "Pre Borrow") && (
                    <hr className="mt-1 mb-1" />
                  )}

                  <div
                    className="w-100 sm-md-overflow-x"
                    id="locate-adder"
                    style={{
                      height: getDivHeight(
                        "locate-tab-list",
                        selectedTab === "Most Located" ||
                          selectedTab === "Inventory"
                          ? 20
                          : 55
                      ),
                    }}
                  >
                    <LocateAdders
                      refreshLocates={refreshLocates}
                      refreshPreBorrows={refreshPreBorrows}
                      refreshMostLocated={refreshMostLocated}
                      selectedTab={selectedTab}
                      currentGridRef={currentGridRef}
                      isAdmin={true}
                      selectedTicker={selectedTickerCode}
                      currentGridApi={currentGridApi}
                      date={date}
                      insertNewRow={insertNewRow}
                      selectedRows={selectedRows}
                      locateSupplyGridRef={locateSupplyGridRef}
                      locateMostGridRef={locateMostGridRef}
                      applyLocateSourceFilter={(filters: any) => {
                        setSourceFilter(filters);
                      }}
                      onInputTicker={(ticker) => {
                        setTickerInput(ticker);
                      }}
                      onResetFilter={(isReset: boolean) => {
                        setIsResetFilter(isReset);
                      }}
                      onDeselectAll={() => {
                        setIsDeselectAll(!isDeselectAll);
                      }}
                      applyLocateStatusFilter={(filters: any) => {
                        setStatusFilter(filters);
                      }}
                      refreshInquiries={refreshInquiries}
                      inquiryLocateRequest={locateRequest}
                      onToggleTotalRow={(isTotal: boolean) =>
                        setShowTotalRow(isTotal)
                      }
                      onShowFilledLocates={(isShow: boolean)=>{setIsShowFilledLocates(isShow)}}
                      onCurrentKPITickerChange={(ticker: any)=>{onCurrentKPITickerChange(ticker)}}
                      isRefreshTickerKPI={isRefreshTickerKPI}
                    />

                    <TabPanel
                      className="w-100 p-1 locate-panel-most-locates"
                      value="Enquiry"
                      style={{ height: getMLCardHeight(-40) }}
                    >
                      <Split
                        initialPrimarySize={isSmallerDeviceRes ? "35%" : "45%"}
                        horizontal={isSmallerDeviceRes}
                      >
                        <div style={{ height: getMLCardHeight() }}>
                          <EnquiryGridWorkbook
                            getGridApi={(gridApi: any) => {
                              setCurrentGridApi(gridApi);
                            }}
                            setSelectedRows={(rows: any) =>
                              setSelectedRows(rows)
                            }
                            isAdmin={true}
                            insertNewRow={insertNewRow}
                            onRefreshLocateKPI={()=> getLocatesKPI()}
                          ></EnquiryGridWorkbook>
                        </div>
                        <div style={{ height: getMLCardHeight(10) }}>
                          <EnquiryGrid
                            type="enquiry"
                            getBtnRef={(gridRef: any) => {
                              setCurrentGridRef(gridRef);
                            }}
                            onRowSelect={(row: any) => {
                              setSelectedRow(row);
                            }}
                            isInquiriesRefreshed={isInquiriesRefreshed}
                            onLocate={(row: any) => {
                              setLocateRequest(row);
                            }}
                            date={date}
                            newRows={newRows}
                            enableSocketUpdates={enableSocketUpdates}
                            currentInterval={currentInterval}
                            isAdmin={true}
                            globalClient={currentClient}
                            clientList={clientShortNameList}
                          ></EnquiryGrid>
                        </div>
                      </Split>
                    </TabPanel>
                    <TabPanel
                      className="w-100 p-1 locate-panel"
                      value="Locates"
                      style={{
                        height: isSmallerDeviceRes ? "100%" : locateHeight,
                      }}
                    >
                      <Split
                        initialPrimarySize={isSmallerDeviceRes ? "35%" : "65%"}
                        horizontal={isSmallerDeviceRes}
                      >
                        <div style={{ height: locateHeight }}>
                          <LocatesGrid
                            isAdmin={true}
                            isLocatesRefreshed={isLocatesRefreshed}
                            getBtnRef={(gridRef: any) => {
                              setCurrentGridRef(gridRef);
                            }}
                            onRowSelect={(row: any) => {
                              setSelectedRow(row);
                              setCurrentLocateGrid("locates");
                            }}
                            getGridApi={(gridApi: any) => {
                              setCurrentGridApi(gridApi);
                            }}
                            date={date}
                            newRows={newRows}
                            setSelectedRows={(rows: any) =>
                              setSelectedRows(rows)
                            }
                            sourceFilter={sourceFilter}
                            statusFilter={statusFilter}
                            // isExcludeApproved={isExcludeApproved}
                            globalClient={currentClient}
                            enableSocketUpdates={enableSocketUpdates}
                            currentInterval={currentInterval}
                            isResetFilters={isResetFilter}
                            isDeselectAll={isDeselectAll}
                            showTotalRow={showTotalRow}
                            clientList={clientShortNameList}
                            onIsRefreshTickerKPI={(isRefresh: boolean)=> setIsRefreshTickerKPI(isRefresh)}
                            currentKPITicker={currentKPITicker}
                          />
                        </div>
                        <div
                          style={{
                            height: isSmallerDeviceRes ? "100%" : locateHeight,
                          }}
                        >
                          <hr className="mt-0 mb-1"></hr>
                          <Split horizontal initialPrimarySize={"50%"}>
                            <div className="h-100" id="locates-most">
                              <div className="d-flex flex-row justify-content-between">
                                <Typography
                                  style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "400",
                                    fontFamily: "Cairo",
                                  }}
                                  className="d-flex flex-row justify-content-start"
                                >
                                  Most Located
                                </Typography>
                                <Icon
                                  icon={"material-symbols:refresh"}
                                  onClick={() =>
                                    setIsMostLocatedRefreshed(
                                      !isMostLocatedRefreshed
                                    )
                                  }
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "0.5rem",
                                    color: "#1E355E",
                                  }}
                                ></Icon>
                              </div>
                              <div
                                className="px-0 py-1"
                                style={{ height: "97%" }}
                              >
                                <MostLocatesGrid
                                  isMostLocatesRefreshed={
                                    isMostLocatedRefreshed
                                  }
                                  getBtnRef={(gridRef: any) => {
                                    setLocateMostGridRef(gridRef);
                                  }}
                                  getGridApi={(gridApi: any) => {
                                    // setCurrentGridApi(gridApi);
                                  }}
                                  date={date}
                                  isLocateTab={true}
                                  onRowSelect={(row: any) => {
                                    setSelectedRow(row);
                                    setCurrentLocateGrid("most-locates");
                                  }}
                                  isAdmin={true}
                                  inputTicker={inputTicker}
                                  isResetFilter={isResetFilter}
                                  globalClient={currentClient}
                                />
                              </div>
                            </div>
                            <div className="h-100" id="locates-supply">
                              {/* <div className="d-flex flex-row justify-content-between"> */}
                              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">

                                <Typography
                                  style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "400",
                                    fontFamily: "Cairo",
                                  }}
                                  className="d-flex flex-row justify-content-start"
                                >
                                  Supply
                                </Typography>
                                <Icon
                                  icon={"material-symbols:refresh"}
                                  onClick={getSupplyInfo}
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "0.5rem",
                                    color: "#1E355E",
                                  }}
                                ></Icon>
                              </div>
                              <div
                                className="px-0 py-1"
                                style={{ height: "100%" }}
                              >
                                <CommonAgGrid
                                  rowData={supplyRows}
                                  columnDefinitions={locateSupplyColDef}
                                  type="Inventory"
                                  isTotalRowHide={true}
                                  getBtnRef={(gridRef: any) => {
                                    setLocateSupplyGridRef(gridRef);
                                  }}
                                  getGridApi={(gridApi: any) => {
                                    // setGridApiSec(gridApi);
                                  }}
                                  onRowSelect={(row: any) => {
                                    setSelectedRow(row);
                                    setCurrentLocateGrid("locates-supply");
                                  }}
                                />
                              </div>
                            </div>
                          </Split>
                        </div>
                      </Split>
                    </TabPanel>
                    <TabPanel
                      className="w-100 p-1 locate-panel"
                      value="Pre Borrow"
                      style={{ height: getCardHeight() }}
                    >
                      <PreBorrowGrid
                        isPreBorrowsRefreshed={isPreBorrowsRefreshed}
                        getBtnRef={(gridRef: any) => {
                          setCurrentGridRef(gridRef);
                        }}
                        onRowSelect={(row: any) => {
                          setSelectedRow(row);
                        }}
                        getGridApi={(gridApi: any) => {
                          setCurrentGridApi(gridApi);
                        }}
                        date={date}
                        newRows={newRows}
                        isAdmin={true}
                        globalClient={currentClient}
                        enableSocketUpdates={enableSocketUpdates}
                        onRefreshLocateKPI={()=> getLocatesKPI()}
                      />
                    </TabPanel>
                    <TabPanel
                      className="w-100 p-1 locate-panel-most-locates"
                      value="Most Located"
                      style={{ height: getMLCardHeight() }}
                    >
                      <MostLocatesGrid
                        isMostLocatesRefreshed={isMostLocatedRefreshed}
                        getBtnRef={(gridRef: any) => {
                          setCurrentGridRef(gridRef);
                        }}
                        getGridApi={(gridApi: any) => {
                          setCurrentGridApi(gridApi);
                        }}
                        date={date}
                        isLocateTab={false}
                        isAdmin={true}
                        globalClient={currentClient}
                        isShowFilledLocates={isShowFilledLocates}
                      />
                    </TabPanel>
                  </div>
                </TabContext>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default LocateDashboard;
